<template>
<div class="surveillance-edit-modal">
  <modal v-model="editModal"
         size="lg"
         :footer="false"
         :header="false">
    <div v-if="editModal"
         class="edit-modal">
      <div class="edit-div-with-padding">
        <h3>
          {{ surveillance.establishment.name }}
        </h3>
        <hr />
        <h3>Protocoles</h3>
        <div class="row">
          <div v-for="p in allProtocols"
               class="col-xs-4 protocols"
               :key="`protocol-${p.type}`">
            <c-checkbox :type="p.type" v-model="protocols[p.type]" block>
              {{ p.label }}
            </c-checkbox>
          </div>
        </div>
        <hr />
        <h3>Ufs</h3>
        <div class="row">
          <div v-for="(p, i) in availableProtocolsWithUfs"
               :key="`uf-protocol-${p.type}`">
            <div class="col-xs-6">
              <unit-list v-model="p.units"
                         :type="p.type"
                         :title="p.label"
                         :unitTypes="p.unitTypes"></unit-list>
            </div>
            <div class="clearfix" v-if="i % 2 === 1"></div>
          </div>
        </div>
        <alert v-if="error !== ''" type="danger">
            <p><strong>Attention !</strong></p>
            <p>
            {{ error }}
          </p>
        </alert>
        <btn type="warning" :disabled="!modified" @click="save">
          Enregistrer les modifications
        </btn>
      </div>
    </div>
  </modal>
</div>
</template>

<script>
import modules from '@/sui/data/modules'
import units from '@/sui/data/units'
import unitList from '@/sui/components/unitlist'
import checkbox from '@/sui/components/checkbox'

export default {
  name: 'surveillance-edit-modal',

  props: {
    surveillance: Object,

    value: {
      type: Boolean,
      required: true
    }
  },

  data () {
    const protocols = {}
    const units = {}
    for (let m in modules) {
      const mod = modules[m]
      if (mod.sheets != null) {
        protocols[m] = false
        units[m] = null
      }
    }

    return {
      editModal: this.value,
      protocols: protocols,
      units: units,
      error: '',
      waiting: false
    }
  },

  computed: {
    unitTypes: function () {
      const neo = []
      const dia = []
      const rea = []
      units.rea.forEach(
        u => {
          if (units.isNeo(u.index)) {
            neo.push(u)
          } else if (units.isDia(u.index)) {
            dia.push(u)
          } else if (units.isMix(u.index)) {
            neo.push(u)
            rea.push(u)
          } else {
            rea.push(u)
          }
        }
      )

      return {
        reaBactADI: units.rea,
        reaInfADI: rea,
        diaInfADI: dia,
        neoInfADI: neo
      }
    },

    availableProtocolsWithUfs: function () {
      const result = []
      for (let p in this.protocols) {
        if (this.protocols[p] && this.units[p] != null) {
          const mod = modules[p]
          result.push(
            {
              type: p,
              label: mod.label,
              units: this.units[p],
              unitTypes: this.unitTypes[p]
            }
          )
        }
      }
      return result
    },

    allProtocols: function () {
      const result = []
      for (let m in modules) {
        const mod = modules[m]
        if (mod.sheets != null) {
          result.push(
            {
              type: m,
              label: mod.label,
              class: `label label-${m}`
            }
          )
        }
      }
      return result
    },

    modified: function () {
      return this.modalitiesModified
    },

    modalitiesModified: function () {
      this.setError('')
      const different = (f, s) => {
        if ((f == null) !== (s == null)) {
          return true
        }

        if (f.length !== s.length) {
          return true
        }

        for (let i in f) {
          const b = f[i]
          const same = (a) => a.type === b.type && a.name === b.name
          if (s.find(same) === -1) {
            return true
          }
        }
        return false
      }

      const f = this.surveillance.modules
      const s = this.protocols
      const u = this.units
      for (let p in s) {
        const mod = f[p]
        const exists = mod != null
        if ((s[p] !== exists) ||
            (exists && mod.ufs != null && different(u[p], mod.ufs))) {
          return true
        }
      }

      return false
    }
  },

  watch: {
    editModal: {
      handler () {
        this.$emit('input', this.editModal)
        if (!this.editModal) {
          this.refresh()
        }
      },
      deep: true
    },

    value: function (value) {
      this.editModal = value
    },

    surveillance: function () {
      this.refresh()
    }
  },

  methods: {
    refresh: function () {
      const smod = this.surveillance.modules
      for (let p in modules) {
        const mod = modules[p]
        if (mod.sheets != null) {
          this.protocols[p] = smod[p] != null
          if (smod[p] != null && smod[p].ufs != null) {
            this.units[p] = smod[p].ufs.slice()
          } else if (mod.ufs) {
            this.units[p] = []
          }
        }
      }
    },

    setError: function (e) {
      this.error = e
    },

    save: function () {
      this.setError('')

      if (this.modalitiesModified) {
        let onep = false
        for (let p in this.protocols) {
          if (this.protocols[p]) {
            onep = true
            break
          }
        }
        if (!onep) {
          this.setError(`Au moins unprotocole doit être sélectionné.`)
          return
        }

        let allUnits = []
        let duplicates = []
        for (let p in this.availableProtocolsWithUfs) {
          const prot = this.availableProtocolsWithUfs[p]
          if (prot.units.length === 0) {
            this.setError(`Il doit y avoir au moins une UF dans ${prot.label}.`)
            return
          } else {
            for (let i in prot.units) {
              const u = prot.units[i]
              const same = (a) => a.type === u.type && a.name === u.name
              if (allUnits.find(same)) {
                duplicates.push(`${u.name} (${prot.label})`)
              } else {
                allUnits.push(u)
              }
            }
          }
        }

        if (duplicates.length > 0) {
          this.setError(`Certaines ufs sont déclarées plusieurs fois, merci
de ne laisser qu'un seul exemplaire de chaque : ${duplicates.join(', ')}.`)
          return
        }

        const u = {}
        for (let p in this.protocols) {
          if (this.protocols[p]) {
            u[p] = this.units[p]
          }
        }

        const request = {
          target: this.surveillance,
          protocols: this.protocols,
          units: u
        }
        const vm = this
        this.$store.dispatch('surveillances/updateSubscription', request).then(
          (response) => {
            if (response.data.err != null) {
              this.setError(`Une erreur est survenue pendant la modification
de la surveillance : ${response.data.err}`)
            } else {
              vm.$notify({
                type: 'success',
                title: 'Succès !',
                content: `L'inscription de l'établissement
${vm.surveillance.establishment.name} a été mise à jour avec succès.`
              })
              this.editModal = false
            }
          }
        ).catch(e => {
          this.setError(`Une erreur est survenue pendant la modification
de l'inscription : ${e}`)
        })
      }
    }
  },

  mounted: function () {
    this.refresh()
  },

  components: {
    'unit-list': unitList,
    'c-checkbox': checkbox
  }
}
</script>

<style lang="less">
.edit-modal {
    h3 {
        margin-bottom: 2rem;
        .label {
            padding: 0.2rem 0.5rem;
        }
    }

  .input-group {
    .label {
      font-size: 100%;
    }
  }

  .protocols {
    .c-checkbox {
      margin-bottom: 0.5rem;
    }
  }
}
</style>
